import type { SubscriptionProductResponse } from "@/domains/careplan/models/types";

export const createCareplanSubscriptionProductDataModel = (
  product: SubscriptionProductResponse,
) => {
  return {
    ...product,
    name: product.title,
    shortName: product.title,
    priceAsString: `${product.price.toFixed(2)}`,
    merchandiseId: product.variantId,
    image: product.url,
    id: product.id.toString(),
    isActive: true,
  };
};
